import { Component, OnInit } from '@angular/core';

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';



@Component({
  selector: 'app-constantes',
  templateUrl: './constantes.component.html',
  styleUrls: ['./constantes.component.css']
})
export class ConstantesComponent implements OnInit {

	allConstantes = [] ;

	dataSourceConstante : MatTableDataSource<any> ;

	choosenId : any ;

	displayedColumnsConst: string[] = ['nomconst', 'description', 'valeur'];


	constructor() { }

	ngOnInit(): void {
	}

	onConstChange(event){
	    let choosenIndex = event.value ;    
	    if(choosenIndex!=-1){
	      this.choosenId = choosenIndex ;       
	    }
	}

	saveConstante(){

	}

	getAllConstantes(){
		
	}


}
